<template>
  <div class="tracking-shortcut" v-if="seccion_actual !== 'tracking_bookings'">
    <router-link to="/lineas/tracking_bookings">
      <Button
        :size="17"
        color="#dc3545"
        colorText="#ffffff"
        tooltip="Tracking Bookings"
        icon="fas fa-ship"
        round
        :width="35"
        class="ml-1 mr-1"
        style="margin-top:9px"
      />
    </router-link>
  </div>
</template>

<script>

import Button from "@/components/common/Button.vue";
import { mapState } from "vuex";

export default {

  data() {

    return {};

  },

  computed: {
    ...mapState(["seccion_actual"]),
  },

  components: {
    Button,
  },

  methods: {}

};
</script>

<style></style>
